<div class="discount-groups-dialog">
  <lp-view-discount-group-row
    *ngFor="let discountGroup of product.terms"
    [discountGroup]="discountGroup"
    [isUserOrganisation]="isUserOrganisation"
    [isUserAssociation]="isUserAssociation"
    [productUnionId]="externalUnionId"
    (getDiscount)="getDiscount($event)"
  ></lp-view-discount-group-row>
</div>
